import MainLayout from "@/components/layout/MainLayout.vue";
import DatePicker from 'vue2-datepicker';
import Pagination from 'laravel-vue-pagination';
import axios from "axios";
import { mapGetters } from "vuex";
import store from "@/store";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import CONFIG from '@/assets/js/config.js';

const convertNumberService = new ConvertNumService();

export default {
    name: "assignmentList",

    components: {
        MainLayout,
        Pagination,
        AdvancedLaravelVuePaginate,
        DatePicker
    },

    data() {
        return {
            assignments: {},
            classes: {},
            keyword: "",
            class_type: 0,
            end_date: "",
            pag_status: false,
            lastPage: "",
            currentPage: "",
            currentDate: "",
            CONFIG
        };
    },

    computed: {
        ...mapGetters(["studentId", "userType"]),
    },

    methods: {
        search(page = 1) {
            this.pag_status = true;
            axios.get("my/assignment/list/search?page=" + page, {
                params: {
                    keyword: this.keyword,
                    end_date: this.end_date,
                    class_type: !this.class_type ? '' : this.class_type
                }
            })
                .then((response) => {
                    this.assignments = response.data;
                    this.assignments.total = convertNumberService.convertEng2Mm(this.assignments.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.assignments.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.assignments.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Student Assignment Search API Error", error);
                });
        },

        getAssignmentList(page = 1) {
            axios.get("my/assignment/list?page=" + page)
                .then((response) => {
                    this.assignments = response.data;
                    this.assignments.total = convertNumberService.convertEng2Mm(this.assignments.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.assignments.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.assignments.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Student Assignment Request API Error", error);
                });
        },

        notificationCount() {
            var id = null;
            var type = this.userType;
            if (this.teacherId) {
                id = this.teacherId;
            }
            if (this.studentId) {
                id = this.studentId;
            }
            axios.get("my/notification/count", {
                params: {
                    id: id,
                    type: type
                }
            })
                .then(response => {
                    store.commit("setNotificationCount", response.data);
                })
                .catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log(error, "error");
                });
        },
    },

    mounted() {
        this.getAssignmentList();
        this.notificationCount();
    }
};
